import React from 'react'

const Aboutus = () => {
  return (
    <div>
        <h1>About Us</h1>
    </div>
  )
}

export default Aboutus
